import { Tag } from "antd"
import PropTypes from "prop-types"
import { colors } from "themes/variables"

const selectedColor = {
  "Booking Request": colors.warning,
  Upcoming: colors.sportsmanBrand,
  Canceled: colors.error,
  Completed: colors.success,
  Paid: colors.success,
  "Payment Outstanding": colors.warning,
  "Partially Refunded": colors.warning,
  Refunded: colors.sportsmanBrand
}

const StatusTag = ({ status }) => {
  return (
    <Tag
      title={status}
      className={`px-s mr-0 py-xxs border-0`}
      style={{
        maxWidth: "fit-content",
        color: selectedColor[status],
        backgroundColor: selectedColor[status] + "26"
      }}
    >
      {status}
    </Tag>
  )
}

StatusTag.propTypes = {
  status: PropTypes.string
}

export default StatusTag
